import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link, useParams} from 'react-router-dom';
import {BtnBorder, BtnSubmit} from '../components/buttons';

import api from '../api';
import auth from '../auth';
import validate from '../validate';

import LogoImage from 'url:../images/logo@2x.png';
import {Form, FormControl, FormError} from '../components/form';
import {Wrap, Float} from '../components/common';
import {Helmet} from 'react-helmet';
import config from '../config';
import {useToast} from '../toast';
const {siteName} = config;

export default () => {
  const { passcode } = useParams();
  const history = useHistory();
  const [success, setSuccess] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if ( passcode ) {
      api.post('/students/finalize', {passcode})
        .then((res) => {
          setSuccess(true);
        }).catch(error => {
          if ( error.code == 422 ) {
            toast.error('登録済のメールアドレスです');
          } else {
            toast.error('無効なパスコードです');
          }
          history.push('/student/confirm');
        });
    }
  }, []);

  return (
      <Wrap>
        <Helmet>
          <title>Eメール登録完了 | {siteName}</title>
        </Helmet>
        <Float>
          <div css={css`text-align: center; margin: 0 0 30px;`}>
            <img src={LogoImage} css={css`max-width: 100%; width: 247.29px;`}/>
          </div>
          <p>Eメールアドレスが確認出来ました</p>
          <div css={css`margin-top: 2rem`}>
            <BtnBorder to="/" name="マイページへ" />
          </div>
        </Float>
      </Wrap>
  );
}
